{
  
  //adds SVG link
  function addOutboundSVG(link) {
    link.insertAdjacentHTML('beforeend', '<svg class="outbound-svg ml-1" aria-hidden="true" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M3.25 4.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V7a.5.5 0 0 1 1 0v5.75a1.75 1.75 0 0 1-1.75 1.75h-7.5a1.75 1.75 0 0 1-1.75-1.75v-7.5A1.75 1.75 0 0 1 3.25 3.5h5.234a.5.5 0 0 1 0 1H3.25ZM10 2a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0v-3h-3A.5.5 0 0 1 10 2Z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M14.104 1.896a.5.5 0 0 1 0 .708l-6.75 6.75a.5.5 0 0 1-.708-.708l6.75-6.75a.5.5 0 0 1 .708 0Z" clip-rule="evenodd"></path></svg>');
  }

  function manageLink(link) {
    if (link.getAttribute('target') == '_blank') {
      if(link.href.indexOf("mailto:") != -1){
        //addMailSVG(link)
      } else if(link.href.indexOf("tel:") != -1){
        //addPhoneSVG(link)
      } else {
        addOutboundSVG(link)
      }
    }
  }

  function externalLinkHelper() {
    const all_links = document.querySelectorAll('a')
    if (all_links) {
      all_links.forEach(link => {
        if (!link.hasAttribute('ada-link-managed')) {
          link.setAttribute('ada-link-managed', 1)
        }
          manageLink(link)
      })
    }

    //hook into jQuery AJAX and handle links after it loads
    //jQuery(document).ajaxComplete(() => setTimeout(externalLinkHelper));
  }

  externalLinkHelper()
}